// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&family=Source+Sans+Pro:wght@400;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px;
  border: 2px dashed #dee2e6;
  border-radius: 15px;
  background-color: #f5f7fa;
  transition: all 0.2s ease-in-out;
  overflow: hidden;
  font-family: 'Montserrat', sans-serif;
  overflow: hidden;
}


.upload-instruction-text {
  margin-bottom: 15px;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 0.95rem;
  font-weight: 400;
  color: #6c757d;
}

.upload-card.drag-active {
  border-color: #0d6efd;
  background-color: #f8f9fa;
}

.icon-stack {
  position: relative;
  width: 70px;
  height: 55px;
  margin: 0 auto;
}

.btn-custom-light {
  border: none;
  border-radius: 5px;
  background: rgb(195, 155, 34);
  padding: 10px;
  color: #fff;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
}

.icon-box {
  position: absolute;
  width: 40px;
  height: 50px;
  border-radius: 6px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  top: 0;
  left: 50%;
  transform: translateX(-50%);
}

.bg-orange {
  background-color: #fd7e14;
}

.rotate-right {
  transform: translateX(-15%) rotate(15deg);
  z-index: 1;
}

.rotate-left {
  transform: translateX(-85%) rotate(-10deg);
  z-index: 1;
}

.icon-box.bg-primary {
  z-index: 2;
}


.upload-instruction-text {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 0.95rem;
  font-weight: 400;
  color: #6c757d;
}

@media (min-width: 768px) {
  /* .upload-card {
    min-height: 300px;
  } */

  .icon-stack {
    width: 90px;
    height: 70px;
  }

  .icon-box {
    width: 50px;
    height: 65px;
  }

  .upload-instruction-text {
    font-size: 1.1rem;
  }
}

.btn-light {
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  background-color: #f1f3f5 !important;
  border: none !important;
  color: #495057 !important;
  white-space: nowrap;
}

.remove-image-btn {
  position: absolute;
  top: -12px;
  right: -12px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background-color: #dc3545; 
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 500;
  line-height: 1;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.remove-image-btn:hover {
  background-color: #bb2d3b;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/UploadImage/UploadImage.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;EAChB,qCAAqC;EACrC,gBAAgB;AAClB;;;AAGA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,WAAW;EACX,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,MAAM;EACN,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,UAAU;AACZ;;AAEA;EACE,0CAA0C;EAC1C,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;;AAGA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;;KAEG;;EAEH;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,oCAAoC;EACpC,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&family=Source+Sans+Pro:wght@400;600&display=swap');\n\n.upload-card {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 40px;\n  border: 2px dashed #dee2e6;\n  border-radius: 15px;\n  background-color: #f5f7fa;\n  transition: all 0.2s ease-in-out;\n  overflow: hidden;\n  font-family: 'Montserrat', sans-serif;\n  overflow: hidden;\n}\n\n\n.upload-instruction-text {\n  margin-bottom: 15px;\n  font-family: 'Source Sans Pro', sans-serif;\n  font-size: 0.95rem;\n  font-weight: 400;\n  color: #6c757d;\n}\n\n.upload-card.drag-active {\n  border-color: #0d6efd;\n  background-color: #f8f9fa;\n}\n\n.icon-stack {\n  position: relative;\n  width: 70px;\n  height: 55px;\n  margin: 0 auto;\n}\n\n.btn-custom-light {\n  border: none;\n  border-radius: 5px;\n  background: rgb(195, 155, 34);\n  padding: 10px;\n  color: #fff;\n  font-family: 'Montserrat', sans-serif;\n  font-weight: 600;\n}\n\n.icon-box {\n  position: absolute;\n  width: 40px;\n  height: 50px;\n  border-radius: 6px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.bg-orange {\n  background-color: #fd7e14;\n}\n\n.rotate-right {\n  transform: translateX(-15%) rotate(15deg);\n  z-index: 1;\n}\n\n.rotate-left {\n  transform: translateX(-85%) rotate(-10deg);\n  z-index: 1;\n}\n\n.icon-box.bg-primary {\n  z-index: 2;\n}\n\n\n.upload-instruction-text {\n  font-family: 'Source Sans Pro', sans-serif;\n  font-size: 0.95rem;\n  font-weight: 400;\n  color: #6c757d;\n}\n\n@media (min-width: 768px) {\n  /* .upload-card {\n    min-height: 300px;\n  } */\n\n  .icon-stack {\n    width: 90px;\n    height: 70px;\n  }\n\n  .icon-box {\n    width: 50px;\n    height: 65px;\n  }\n\n  .upload-instruction-text {\n    font-size: 1.1rem;\n  }\n}\n\n.btn-light {\n  font-family: 'Montserrat', sans-serif;\n  font-weight: 600;\n  background-color: #f1f3f5 !important;\n  border: none !important;\n  color: #495057 !important;\n  white-space: nowrap;\n}\n\n.remove-image-btn {\n  position: absolute;\n  top: -12px;\n  right: -12px;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: none;\n  background-color: #dc3545; \n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 1;\n  cursor: pointer;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.remove-image-btn:hover {\n  background-color: #bb2d3b;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
